var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleSheetsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "10 5 25 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.716 18.8v2.4h12.572v-2.4H15.716zM15.716 25.2v-2.4h3.143v2.4h-3.143zM15.716 26.8v2.4h3.143v-2.4h-3.143zM20.428 26.8v2.4h3.143v-2.4h-3.143zM25.14 26.8v2.4h3.143v-2.4h-3.142zM25.14 25.2v-2.4h3.143v2.4h-3.142zM23.571 25.2h-3.143v-2.4h3.143v2.4z",
    fill: "#389E0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.714 6H11.786a.779.779 0 00-.556.234.808.808 0 00-.23.566v30.4c0 .212.083.416.23.566.147.15.347.234.556.234h20.428a.779.779 0 00.556-.234.808.808 0 00.23-.566V12.4h-5.5a.779.779 0 01-.556-.234.808.808 0 01-.23-.566V6zM14.143 18c0-.212.083-.416.23-.566a.779.779 0 01.556-.234H29.07c.209 0 .409.084.556.234.147.15.23.354.23.566v12a.807.807 0 01-.23.566.779.779 0 01-.556.234H14.93a.779.779 0 01-.556-.234.807.807 0 01-.23-.566V18z",
    fill: "#389E0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.543 10.8H28.29V6.468l4.254 4.332z",
    fill: "#389E0D"
  })));
}

export default __webpack_public_path__ + "./fonts/google-sheets-logo.1f77bce41b62d1dca31736ac8f9d32b8.svg";
export { SvgGoogleSheetsLogo as ReactComponent };